export class CallbackParams {
    constructor(public modal_name: string) {}
}
